/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

export const SIGN_IN_ROUTER_STATE = 'sign-in';

export const BACKGROUNDS = {
  standard: ['melbourne', 'oslo', 'mtcook'],
  masquerade: ['nz']
};

export interface SignInView {
  id: string;
  title: string;
  username?: boolean;
  usernameAlways?: boolean;
  gravatar?: boolean;
  password?: boolean;
  confirmPassword?: boolean;
  passwordHint?: boolean;
  resetMessage?: boolean;
  hasResetMessage?: boolean;
  hasOverloadMessage?: boolean;
  masquerade?: boolean;
  forgotPassword?: boolean;
  diffAccount?: boolean;
  passkeyButton?: boolean;
  twoFactorAuth?: boolean;
  buttonText: string | false;
  submitMethod: string;
}

export const VIEWS: Record<string, SignInView> = {
  SIGN_IN: {
    id: 'SIGN_IN',
    title: 'Sign in',
    username: true,
    gravatar: true,
    password: true,
    resetMessage: false,
    masquerade: false,
    forgotPassword: true,
    diffAccount: true,
    passkeyButton: true,
    buttonText: 'Sign in',
    submitMethod: 'signIn'
  },
  RESET_PASSWORD: {
    id: 'RESET_PASSWORD',
    title: 'Reset Your Password',
    username: true,
    usernameAlways: true,
    gravatar: false,
    password: false,
    passkeyButton: false,
    resetMessage: true,
    masquerade: false,
    forgotPassword: false,
    diffAccount: false,
    buttonText: 'Send Password Reset Email',
    submitMethod: 'resetPassword'
  },
  PASSWORD_HAS_RESET: {
    id: 'PASSWORD_HAS_RESET',
    title: 'Reset Your Password',
    username: false,
    usernameAlways: false,
    gravatar: false,
    resetMessage: false,
    hasResetMessage: true,
    masquerade: false,
    buttonText: false,
    passkeyButton: false,
    submitMethod: 'null'
  },
  PASSWORD_NEEDS_RESET: {
    id: 'PASSWORD_NEEDS_RESET',
    title: 'Your Password has expired and must be reset',
    username: false,
    usernameAlways: false,
    gravatar: false,
    forgotPassword: true,
    resetMessage: false,
    hasResetMessage: true,
    passkeyButton: false,
    masquerade: false,
    buttonText: false,
    submitMethod: 'null'
  },
  TWO_FACTOR_AUTH: {
    id: 'TWO_FACTOR_AUTH',
    title: 'Enter Two-Factor Authentication Code',
    username: false,
    usernameAlways: false,
    gravatar: false,
    resetMessage: false,
    hasResetMessage: false,
    masquerade: false,
    passkeyButton: false,
    buttonText: 'Sign in',
    twoFactorAuth: true,
    submitMethod: 'signIn2fa'
  },
  PASSWORD_OVERLOAD: {
    id: 'PASSWORD_OVERLOAD',
    title: 'Reset Your Password',
    username: false,
    usernameAlways: false,
    gravatar: false,
    resetMessage: false,
    passkeyButton: false,
    hasOverloadMessage: true,
    masquerade: false,
    buttonText: false,
    submitMethod: 'null'
  },
  PASSWORD_UPDATE: {
    id: 'PASSWORD_UPDATE',
    title: 'Update Your Password',
    password: true,
    confirmPassword: true,
    passwordHint: true,
    passkeyButton: false,
    buttonText: 'Update Password',
    submitMethod: 'updatePassword'
  },
  MASQUERADE: null as any
};

VIEWS.MASQUERADE = _.assign({}, VIEWS.SIGN_IN, {
  id: 'MASQUERADE',
  masquerade: true
});
